import * as types from './types';

const convertPostingToFull = postingId => {
  return {
    type: types.CONVERT_TO_FULL,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/postingFull/${postingId}`,
      method: 'POST'
    }
  };
};

export { convertPostingToFull };
